import { useCallback, useState } from "react";
import TextContentWrapper from "../../../common/TextContentWrapper";
import { ImageContainer, ImageContentClickable } from "./ImageContent.style";
import MessageImageThumbnail from "./MessageImageThumbnail";
import ExpandableText from "../../../common/ExpandableText";

type ImageContentItemProps = {
  imageUrl: string;
  text: string;
  isPendingMessage: boolean;
  onOpenModal: () => void;
};

const ImageContentItem = ({
  imageUrl,
  text,
  isPendingMessage,
  onOpenModal,
}: ImageContentItemProps) => {
  const [imageWidth, setImageWidth] = useState<number | null>(null);

  const handleImageWidthCalculated = useCallback((width: number) => {
    setImageWidth(width);
  }, []);

  return (
    <ImageContainer
      style={{
        maxWidth: imageWidth ? `${imageWidth}px` : "auto",
        width: "100%",
      }}
    >
      <ImageContentClickable
        onClick={onOpenModal}
        data-testid="media-image-content-button"
      >
        <MessageImageThumbnail
          url={imageUrl}
          text={text}
          isPendingMessage={isPendingMessage}
          onImageWidthCalculated={handleImageWidthCalculated}
        />
      </ImageContentClickable>
      {text && (
        <TextContentWrapper>
          <ExpandableText>{text}</ExpandableText>
        </TextContentWrapper>
      )}
    </ImageContainer>
  );
};

export default ImageContentItem;
